var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "417px",
    height: "256px",
    viewBox: "0 0 417 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.5,191.5 C416.5,226.844 387.844,255.5 352.5,255.5 L352.5,256 L80.5,256 C36.312,256 0.5,220.187 0.5,176 C0.5,137.25 28.063,104.937 64.656,97.594 C64.656,97.063 64.5,96.563 64.5,96 C64.5,42.969 107.469,0 160.5,0 C197.938,0 230,21.625 245.844,52.875 C254.219,49.937 263.094,48 272.5,48 C316.344,48 351.844,83.25 352.406,127 L352.5,127 L352.5,127.5 C387.844,127.5 416.5,156.156 416.5,191.5 Z",
    id: "Shape",
    stroke: "none",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.2770fa95df7aeddfda4bcf8d16267595.svg";
export { ForwardRef as ReactComponent };